import { useCallback, useEffect, useRef } from 'react';

import { ColumnsResizing } from '../types/campaignBuilder.js';

type Props = {
  columnResizing?: ColumnsResizing;
  onSaveColumnWidth: (obj: { [name: string]: number }) => void;
  minWidth: number;
};

const useResize = ({
  columnResizing,
  onSaveColumnWidth,
  minWidth = 42,
}: Props) => {
  const columnsRef = useRef<any>({});

  const handleSetColumnRef = useCallback(
    (ref: any, headerId: string) => {
      columnsRef.current[headerId] = ref;
    },
    [columnsRef],
  );

  useEffect(() => {
    if (!columnResizing) {
      return;
    }

    const { columnWidths } = columnResizing;
    Object.keys(columnWidths).forEach((key) => {
      const refsObject = columnsRef.current;
      if (
        !refsObject?.[key] ||
        !columnWidths[key] ||
        refsObject[key].style.width === columnWidths[key]
      ) {
        return;
      }

      refsObject[key].style.width =
        columnWidths[key] > minWidth
          ? `${columnWidths[key]}px`
          : `${minWidth}px`;
    });
  }, [columnResizing?.columnWidths]);

  useEffect(() => {
    const { isResizingColumn, headerIdWidths, columnWidths } =
      columnResizing || {};
    if (!isResizingColumn) {
      //@ts-ignore
      const [name] = headerIdWidths?.[0] || [];
      if (name && columnWidths[name]) {
        onSaveColumnWidth({
          [name]:
            columnWidths[name] > minWidth
              ? Math.floor(columnWidths[name])
              : minWidth,
        });
      }
    }
  }, [columnResizing?.isResizingColumn]);

  return handleSetColumnRef;
};

export default useResize;
